import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BdoApiService } from '../bdo/services/bdo-api.service';
import { ReBaseData } from '../shared/utils/re-base-data';

@Component({
  selector: 'bdo-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UnsubscribeComponent implements OnInit {
  isLoading = true;
  isError = false;
  isSuccess = false;
  errorMessage = '';
  protected reBaseData = ReBaseData;

  constructor(
    private route: ActivatedRoute,
    private bdoApiService: BdoApiService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.isLoading = false;
      this.isError = true;
      this.errorMessage = this.translateService.instant('optout.invalidLink');
      return;
    }

    this.processOptOut(token);
  }

  private processOptOut(token: string): void {
    this.bdoApiService.postOptOutAnonymous(token).subscribe({
      next: () => {
        this.isLoading = false;
        this.isSuccess = true;
      },
      error: (error) => {
        this.isLoading = false;
        this.isError = true;
        if (error.status === 400) {
          this.errorMessage = this.translateService.instant('optout.expiredLink');
        } else {
          this.errorMessage = this.translateService.instant('optout.generalError');
        }
      }
    });
  }
}
